<template>
    <section class="crests" ref="card">
        <slot></slot>
    </section>
</template>
<script setup>
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { onMounted, ref } from 'vue';

gsap.registerPlugin(ScrollTrigger);

const card = ref(null);
const frameCount = 5
const data = {
    frame:0
}
let currentFrame = 0;
let text = null;
let groups = null;

const swapText = () => {
    if(currentFrame != data.frame){
        console.log(data.frame);
        text.querySelectorAll('span').forEach(s => s.classList.remove('active'));
        groups.forEach(g => g.classList.remove('active'));
        if(data.frame > 0){
            groups.item(data.frame-1).classList.add('active');
            text.querySelector('span:nth-child('+data.frame+')').classList.add('active');

        }
        currentFrame = data.frame;
    }
}

onMounted(() => {
    text = card.value.querySelector('.copy');
    groups = card.value.querySelectorAll('svg g:not(#crest)');
    let tl = gsap.timeline({
        defaults:{
            duration:0.5
        },
        scrollTrigger:{
            trigger:card.value,
            start:() => {
                return 'top top+='+document.querySelector('header.main').clientHeight;
            },
            end:() => window.outerHeight * 2.5,
            pin:true,
            scrub:0.5
        }
    });

    tl.to(data, {
        frame:frameCount - 1,
        snap:'frame',
        ease:'none',
        onUpdate:swapText,
        duration:2.5
    });

    tl.from(card.value.querySelectorAll('g#crest path'), {
        fill:'transparent',
        duration:0.4
    }, 0)

})
</script>
